<template>
    <okraina-view :class="['okraina-v-clients']" :refreshDisabled="true" ref="view" :hideMenu="true"
        :contentHorizontalPadding="19">

        <template v-slot:header>
            <h1 class="title">
                Покупателям
            </h1>
        </template>

        <template v-slot:content>

            <div class="spacer"></div>

            <okraina-menu-section :items="items" />


        </template>
    </okraina-view>
</template>

<script>
import okrainaView from "@/components/view2.vue";
import okrainaMenuSection from "@/components/menu.section.vue";


import meta from "@/plugins/meta";
import metaTemplates from "@/plugins/meta/clients.index.js";

export default {
    name: "okraina-v-clients",
    components: {
        okrainaView,
        okrainaMenuSection
    },
    data() {
        return {
            items: [
                {
                    icon: "fi-sale",
                    name: "Акции",
                    description: "Узнай первым о выгодных предложениях нашего магазина!",
                    path: "/clients/actions/"
                },
                {
                    icon: "fi-recipe",
                    name: "Рецепты",
                    description: "Простые рецепты приготовления блюд",
                    path: "/clients/recipes/"
                },
                {
                    icon: "fi-quality-control",
                    name: "Контроль качества PIC",
                    description: "Отслеживание  истории создания  товара  Окраина",
                    path: "/clients/pic/"
                },
                {
                    icon: "fi-reviews",
                    name: "Отзывы",
                    description: "Нам важно ваше мнение!",
                    path: "/clients/reviews/"
                },
            ]
        };
    },

    methods: {

    },

    /**
     * Обраотка переход входом на экран
     */
    beforeRouteEnter() {
        //запишем мета данные страницы
        meta.write(metaTemplates);
    },
}
</script>

<style lang="scss"></style>